import { coerce, nullable, Struct } from "superstruct";

export const coerceNullToUndefined = <T, S>(struct: Struct<T, S>) =>
  coerce(struct, nullable(struct), (v) => (v === null ? undefined : v));
